import { render, staticRenderFns } from "./DynamicEmbebed.vue?vue&type=template&id=27cca2c2&scoped=true"
import script from "./DynamicEmbebed.vue?vue&type=script&lang=js"
export * from "./DynamicEmbebed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cca2c2",
  null
  
)

export default component.exports